<template>
  <section class="text-page">
    <BasicHero
      class="text-page-hero"
      :title="props.data.title"
      :subtitle="props.data.sub" />
    <TextComponent
      class="text-page-content"
      :html="props.data.content" />
  </section>
</template>

<script setup>
/* #META
 {
  "NAME": "TextPageComponent",
  "CLASSNAME": "text-page-module-component",
  "URL": "http://lifemine.local/templates/"
 }
#ENDMETA */

import BasicHero from '@/components/utility/BasicHero.vue'
import TextComponent from '@/components/utility/TextComponent.vue'

const props = defineProps(['data'])
</script>

<style lang="scss">
.text-page {
  &-content {
    @apply mt-[50px] lg:mt-[31px];
  }
}
</style>
